/**
 * @generated SignedSource<<545d1fe3750c79fd57615d8e500ceba6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleAdminItem_routine$data = {
  readonly currentSchedule: {
    readonly __typename: "RoutineScheduleDaily";
    readonly deadlineDuration: number | null;
    readonly isAllDay: boolean | null;
    readonly weekdays: ReadonlyArray<{
      readonly startTime: {
        readonly hour: number;
        readonly minute: number;
      } | null;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleAdminItemTimeIndicator_RoutineScheduleDaily" | "TeamScheduleAdminItemWeekdayIndicator_RoutineScheduleDaily">;
  } | {
    readonly __typename: "RoutineScheduleMonthly";
    readonly endDay: number | null;
    readonly startDay: number;
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleAdminItemMonthDayIndicator_RoutineScheduleMonthly">;
  } | {
    readonly __typename: "RoutineScheduleWeekly";
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleWeeklyWeekdayIndicator_RoutineScheduleWeekly">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleAdminItemComponent_routine">;
  readonly " $fragmentType": "TeamScheduleAdminItem_routine";
};
export type TeamScheduleAdminItem_routine$key = {
  readonly " $data"?: TeamScheduleAdminItem_routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleAdminItem_routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleAdminItem_routine",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamScheduleAdminItemComponent_routine"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentSchedule",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDay",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TeamScheduleAdminItemMonthDayIndicator_RoutineScheduleMonthly"
            }
          ],
          "type": "RoutineScheduleMonthly",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TeamScheduleWeeklyWeekdayIndicator_RoutineScheduleWeekly"
            }
          ],
          "type": "RoutineScheduleWeekly",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAllDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineScheduleDailyWeekday",
              "kind": "LinkedField",
              "name": "weekdays",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Time",
                  "kind": "LinkedField",
                  "name": "startTime",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hour",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minute",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deadlineDuration",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TeamScheduleAdminItemWeekdayIndicator_RoutineScheduleDaily"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TeamScheduleAdminItemTimeIndicator_RoutineScheduleDaily"
            }
          ],
          "type": "RoutineScheduleDaily",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "2787786fbe61a957fa7db71b3e02e32c";

export default node;
